<div class="simple-page-content" style="background-image: url(/assets/images/background/login-bg-{{randomBackgroundImage}}.jpg);">
	<router-outlet></router-outlet>
</div>